import React from 'react'
import { useTranslation } from 'react-i18next'
import { NameStep } from './NameStep'
import { PartsStep } from './PartsStep'
import { DemandsStep } from './DemandsStep'
import { Dialog } from '../../dialog/Dialog'
import { Wizard } from '../../form/Wizard'
import { FormValues } from './form-values'

type Props = {
  isOpen: boolean
  defaultValues: Partial<FormValues>
  onClose: () => void
  onSubmit: (values: FormValues) => void
}

export const BuildingBasicInfoDialog = React.memo(
  ({ isOpen, defaultValues, onClose, onSubmit }: Props): React.ReactElement => {
    const { t } = useTranslation()

    const steps: React.ElementType[] = [NameStep, PartsStep, DemandsStep]

    const isCreating = !defaultValues?.name?.length
    const title = isCreating ? t('project.addBuilding') : defaultValues.name

    return (
      <Dialog title={title ?? ''} open={isOpen} onClose={onClose}>
        <Wizard
          steps={steps}
          defaultValues={defaultValues}
          submitText={
            isCreating ? t('project.addBuilding') : t('common.saveChanges')
          }
          onSubmit={onSubmit}
        />
      </Dialog>
    )
  },
  (prevProps, nextProps) => prevProps.isOpen === nextProps.isOpen,
)
